import Ajv from 'ajv';
import schema from './schema-1501.json';

export const ajv = getInstance();

/**
 * Validate a schema by name
 * @param name The name
 * @param data The data to test
 */
export function valid(name: string, data: unknown): boolean {
	try {
		return ajv.validate(name, data);
	} catch (error) {
		return noSchema(error);
	}
}

/**
 * Creates and compiles all of our schemas
 * @returns Our AJV instance
 */
function getInstance(): Ajv {
	const instance = new Ajv({
		useDefaults: true,
		strict: false,
	});

	Object.keys(schema).forEach((key) => {
		instance.addSchema(schema[key], key);
	});

	return instance;
}

function noSchema(error: any): boolean {
	console.error(error.toString());
	return error.toString().indexOf('no schema with key or ref') > -1;
}
